import tableAppConfig from './tableAppConfig';

export default {
  title: 'Configuration Management',
  attributeName: 'appConfigs',
  getURL: 'appId/appConfigsPlay',
  createURL: 'appId/appConfigsPlay',
  updateURL: 'appId/appConfigsPlay',
  removeURL: 'appId/appConfigsPlay',
  loadFromFile: 'appId/appManualConfigFromFile',
  loadFromFileHelp: 'To load tokens from file.',
  fileExtensionType: ['.json'],
  sessionParams: ['appId'],
  noArea: true,
  removeNameField:'name',
  removeText:'You are about to remove the config with name ##name##.',
  tableConfig: tableAppConfig,
  autoUpdate: true,
  revalidate: true
};
